export default __webpack_public_path__ + "static/media/home-img-business.ba13103c.png";